import React from 'react'
import styled from 'styled-components'
import {connect} from 'react-redux'
import {actions} from '../redux/ducks/main'
import {TransitionMotion, spring} from 'react-motion'

const Container = styled.div`
  position:absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(100, 100, 100, 0.8);
  z-index: 1000;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Content = styled.div`
  background-color: white;
  padding: 10px;
  border-radius: 10px;
  overflow: hidden;
`

const ApiKeyWrap = styled.div`
  display: flex;
  flex-direction: column;
  > * {
    margin-top: 5px;
    margin-bottom: 5px;
  }
`

const ChangeApiKey = styled.div`
  margin-top: 12px;
  text-align: center;
`

class GlobalModal extends React.PureComponent {
  state = {
    inputApiKey: ''
  }
  willEnter = () => ({
    opacity: 1
  })

  willLeave = () => ({
    opacity: spring(0)
  })

  render () {
    const { modal, enterApiKey, storeApiKey } = this.props
    const { inputApiKey } = this.state
    return (
      <TransitionMotion
        willEnter={this.willEnter}
        willLeave={this.willLeave}
        styles={modal.get('show') ? [{ key: 'transition', style: { opacity: spring(1) } }] : []}>
        {interpolatedStyles => {
          if (!interpolatedStyles.length) return null
          return (
            <Container style={{ opacity: interpolatedStyles[0].style.opacity }}>
              <Content>{enterApiKey
                ? <ApiKeyWrap>
                    <div>Bitte Api-Key eingeben</div>
                    <input type='text' value={inputApiKey} onChange={e => this.setState({ inputApiKey: e.target.value.trim() })}/>
                    <button disabled={!inputApiKey} onClick={() => storeApiKey(inputApiKey)}>Speichern</button>
                  </ApiKeyWrap>
                : modal.get('message')}
                {modal.get('showChangeApiKey') && <ChangeApiKey><button onClick={() => storeApiKey(null)}>Change Api-Key</button></ChangeApiKey>}
              </Content>
            </Container>
          )
        }}
      </TransitionMotion>
    )
  }
}

export default connect(
  state => ({
    modal: state.main.modal,
    enterApiKey: !state.main.apiKey
  }),
  dispatch => ({
    storeApiKey: apiKey => dispatch(actions.storeApiKey({ apiKey }))
  })
)(GlobalModal)
